var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 149,
    viewBox: "0 0 100 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2644 5.34351L63.0378 3.81679V8.52672L58.4288 7V1.52672L52.2022 0V6.23664H47.5856V0L41.359 1.52672V7L36.7501 8.52672V3.81679L30.5234 5.34351L30.7447 33.3664H69.0431L69.2644 5.34351Z",
    fill: "#868694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8893 37.3438C60.4672 37.3438 69.0423 35.5632 69.0423 33.3667C69.0423 31.1703 60.4672 29.3896 49.8893 29.3896C39.3114 29.3896 30.7363 31.1703 30.7363 33.3667C30.7363 35.5632 39.3114 37.3438 49.8893 37.3438Z",
    fill: "#4B4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 119.305L50.0038 148.183L100 119.305V61.5496L50.0038 32.6641L0 61.5496V119.305Z",
    fill: "url(#paint0_linear_1729_165)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8878 108.974C46.6513 108.963 43.8556 108.215 41.5007 106.73C39.1458 105.245 37.3304 103.105 36.0543 100.309C34.7783 97.5133 34.1461 94.1607 34.1577 90.2514C34.1693 86.3305 34.8073 83.0012 36.0717 80.2635C37.3478 77.5258 39.1574 75.4435 41.5007 74.0167C43.8556 72.5898 46.6513 71.8764 49.8878 71.8764C53.1243 71.8764 55.92 72.5956 58.2749 74.0341C60.6297 75.4609 62.4452 77.5432 63.7212 80.2809C64.9973 83.0186 65.6295 86.3421 65.6179 90.2514C65.6179 94.1839 64.9799 97.5481 63.7038 100.344C62.4278 103.139 60.6123 105.28 58.2575 106.765C55.9142 108.238 53.1243 108.974 49.8878 108.974ZM49.8878 101.109C51.5582 101.109 52.9271 100.239 53.9943 98.4993C55.0732 96.7476 55.6068 93.9983 55.5952 90.2514C55.5952 87.8037 55.3516 85.8027 54.8643 84.2482C54.3771 82.6938 53.7043 81.5453 52.8459 80.8029C51.9875 80.0489 51.0014 79.6719 49.8878 79.6719C48.2173 79.6719 46.8543 80.5187 45.7987 82.2124C44.743 83.906 44.2036 86.5857 44.1804 90.2514C44.1688 92.7455 44.4066 94.7988 44.8938 96.4112C45.381 98.0121 46.0539 99.1953 46.9123 99.9609C47.7823 100.727 48.7741 101.109 49.8878 101.109Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_165",
    x1: 50,
    y1: 32.6641,
    x2: 50,
    y2: 148.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B7CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel0);
export default __webpack_public_path__ + "static/media/_level-0.cefe9578f68ba40a2cec08bf4ad40b0c.svg";
export { ForwardRef as ReactComponent };